import React, { Component } from 'react'

import './index.scss'

class Checkbox extends Component {
    renderCheckImg = () => {
        const { checkboxType, name, checked, onChange } = this.props
        switch (checkboxType) {
            case 'rounded':
                return (
                    <img
                        className={checked ? "checked" : ""}
                        src="https://front.videomonster.com/images-u6yd72dy/common/v2/checked.svg"
                        alt=""
                        onClick={() => onChange({ target: { name, checked: !checked } })}
                    />
                )
                
            case 'green':
                return (
                    <div
                        className={checked ? "checked" : ""}
                        onClick={() => onChange({ target: { name, checked: !checked } })}
                    >
                        <img src="https://front.videomonster.com/images-u6yd72dy/web/green_checkbox.svg" alt="" />
                    </div>
                )

            default:
                return (
                    <div
                        className={checked ? "checked" : ""}
                        onClick={() => onChange({ target: { name, checked: !checked } })}
                    >
                        <img src="https://front.videomonster.com/images-u6yd72dy/web/normal_checkbox.svg" alt="" />
                    </div>
                )
        }
    }

    render() {
        const { checkboxType, id, label } = this.props
        return (
            <div className={`newform-checkbox-container type-${checkboxType || 'checkbox'}`}>
                <input
                    type="checkbox"
                    id="id"
                    {...this.props}
                />
                {this.renderCheckImg()}
                <label for={id}>{label}</label>
            </div>
        )
    }
}

export default Checkbox